import axios from 'axios';
import useSWR from 'swr';

import { responseInterface } from 'swr/dist/types';

export type SessionAuthProvider = {
  authProvider: 'okta' | 'auth0' | null;
};

const path = `${process.env.GATSBY_MRX_API_PUBLIC_URL?.replace(
  /\/$/,
  ''
)}/session-auth-provider`;

const swrSettings = {
  dedupingInterval: 5000,
  // Needs to actually recur on a timer, not just refetch on
  // mount/focus/reconnect, so a maintenance-triggered Okta logout gets
  // detected promptly even if the user just leaves the tab open.
  refreshInterval: 10000,
};

export const getSessionAuthProvider = async (): Promise<SessionAuthProvider> => {
  const { data } = await axios.get<SessionAuthProvider>(path, {
    withCredentials: true,
  });
  return data;
};

export const useSessionAuthProviderCheck = () =>
  useSWR(path, getSessionAuthProvider, swrSettings) as responseInterface<
    SessionAuthProvider,
    Error
  >;

export default useSessionAuthProviderCheck;
